
// Sample data for the reports page
export const recentReports = [
  {
    title: "Monthly Energy Consumption Report",
    date: "June 1, 2023",
    consumption: 1250,
    status: "completed"
  },
  {
    title: "Quarterly Usage Analysis",
    date: "April 15, 2023",
    consumption: 3450,
    status: "completed"
  },
  {
    title: "Annual Energy Efficiency Report",
    date: "January 10, 2023",
    consumption: 14230,
    status: "pending"
  },
  {
    title: "Peak Demand Cost Analysis",
    date: "December 5, 2022",
    consumption: 5680,
    status: "processing"
  },
  {
    title: "Appliance Efficiency Report",
    date: "November 22, 2022",
    consumption: 2920,
    status: "completed"
  }
];

export const reportStatusColors = {
  completed: "bg-green-500",
  pending: "bg-amber-500",
  processing: "bg-blue-500"
};

export const usageInsights = [
  {
    title: "HVAC & Cooling",
    description: "Heating, ventilation, and cooling account for 42% of your energy consumption.",
    percentage: 42
  },
  {
    title: "Lighting",
    description: "Lighting systems represent 21% of your total energy consumption.",
    percentage: 21
  },
  {
    title: "Equipment & Appliances",
    description: "Office equipment and appliances contribute to 18% of your energy usage.",
    percentage: 18
  },
  {
    title: "Other",
    description: "Miscellaneous energy usage including IT and server rooms make up 19%.",
    percentage: 19
  }
];
